/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Faq_Buy_AInputs */

const en_directory_hubs_signals_faq_buy_a = /** @type {(inputs: Directory_Hubs_Signals_Faq_Buy_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Both scores are computed from public, verifiable signals. Sponsored placements are always labeled and never affect AI-Ready or GEO.`)
};

const zh_directory_hubs_signals_faq_buy_a = /** @type {(inputs: Directory_Hubs_Signals_Faq_Buy_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不能。两个分数都由公开、可验证的信号计算。赞助展示位始终有标注，且绝不影响 AI-Ready 或 GEO。`)
};

/**
* | output |
* | --- |
* | "No. Both scores are computed from public, verifiable signals. Sponsored placements are always labeled and never affect AI-Ready or GEO." |
*
* @param {Directory_Hubs_Signals_Faq_Buy_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_faq_buy_a = /** @type {((inputs?: Directory_Hubs_Signals_Faq_Buy_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Faq_Buy_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_faq_buy_a(inputs)
	return zh_directory_hubs_signals_faq_buy_a(inputs)
});
export { directory_hubs_signals_faq_buy_a as "directory.hubs.signals.faq.buy_a" }